/* eslint-disable import/prefer-default-export */
export const sifrarnici = {
  publicToken: '39039b0c-9fc0-11ec-ba82-00505601007a',
  // publicToken: '39039b0c-9fc0-11ec-ba82-00505601007b' // false publicToken to test what happens

  staza_tipovi: {
    plan_staza: 30,
    pogodna_staza: 90,
    ferrata: 93,
  },

  poi_tipovi: {
    hgss: 20,
    planinarska_kuca: 31,
    planinarski_dom: 32,
    planinarsko_skloniste: 33,
    penjaliste: 40,
    opasnost: 50,
    vrh: 60,
    vidikovac: 70,
    prir_izvor: 71,
    prir_slap: 72,
    prir_spilja: 73,

    kult_arheo: 81,
    kult_mlin: 82,
    kult_muzej: 83,
    kult_sakralni: 84,
    kult_spomenik: 85,
    kult_utvrda: 86,

    polaziste: 90,
    odmoriste: 91,
  },
  toponim_tipovi: {
    planina: 20,
    plan_kuca_dom: 30,
    plan_skloniste: 33,
    penjaliste: 40,
    obilaznica: 50,
    vrh: 60,
    izvor: 71,
    slap: 72,
    spilja: 73,
    arheo: 81,
    mlin: 82,
    muzej: 83,
    sakralni: 84,
    spomenik: 85,
    utvrda: 86,
    polaziste: 90,
    odmoriste: 91,
    rijeka: 96,
    park: 97,
    naselje: 98,
    lokacija: 99,
  },
  svrha_registracije: {
    reg: 10,
    hps: 20,
  },
  status_izleta: {
    draft: 10,
    submitted: 20,
    approved: 30,
  },
  poglavlja_izleta: {
    opis: 1,
    plan_izleta: 2,
    mjesto_vrijeme_polaska: 3,
    povratak: 4,
    zahtjevnost_ture: 5,
    oprema: 6,
    prehrana: 7,
    prijevoz: 8,
    prijava: 9,
    troskovi: 10,
    dokumenti: 11,
    odustanak: 12,
    dodatne_informacije: 13,
    gdpr: 14,
    pravno: 15
  },
  obavezna_poglavlja_izleta: [1, 5, 9],
  vodic_sudionik_uloga: {
		vodic: 10,
		sudionik: 20
	},
  izlet_drzave: {
    hrvatska: 1
  }
};
